import React, { FC } from "react";
import { Link } from "@xometry/xometry_loft";
import { LinksWrapper } from "./CustomerRFQRegister.style";

interface Props {
  WWW_ORIGIN: string;
}

export const RegistrationAgreement: FC<Props> = ({ WWW_ORIGIN }) => {
  return (
    <LinksWrapper>
      By registering, I agree to Xometry&apos;s&nbsp;
      <Link
        href={`${WWW_ORIGIN}/service-agreement`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Customer Service Agreement
      </Link>
      ,&nbsp;
      <Link
        href={`${WWW_ORIGIN}/terms`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms and Conditions
      </Link>
      , and&nbsp;
      <Link
        href={`${WWW_ORIGIN}/privacy-policy/`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </Link>
      .
    </LinksWrapper>
  );
};
